import Axios, { AxiosResponse } from "axios";
import defineHeaderAxios from "@/utilities/useAuthToken";
import VIPContactViewModel from "@/models/VIPContactViewModel";
import { ref } from "vue";
export default function () {
    const VIPcontacts = ref<Array<VIPContactViewModel>>([]);
    const getVIPContacts = async (): Promise<boolean> => {
        try {
            await defineHeaderAxios();
            const result: AxiosResponse<Array<VIPContactViewModel>> =
                await Axios.get("/api/vipcontact");
            if (result.status !== 200 || !Array.isArray(result.data)) {
                throw new Error("VIP contacts response was invalid.");
            }
            VIPcontacts.value = result.data;
            return true;
        } catch (error) {
            console.error("Failed to load VIP contacts.", error);
            return false;
        }
    };
    void getVIPContacts();
    return {
        VIPcontacts,
        getVIPContacts,
    };
}
